import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { ref, reactive, computed, nextTick } from "vue";
import { mapState } from "../../store/map";
import { ElMessage, ElMessageBox } from "element-plus";
import { addArticle, editArticle, getArticleDetails } from "../../api/article";
import { uploadImage } from "../../api/image";
import router from "../../router";
import bus from "../../utils/bus";
import markdownIt from "../../utils/markdown-it";
export default {
  name: "ArticleEdit",
  setup: function setup(props) {
    var isInEditMode = props.id ? true : false;
    var content = ref("");
    var mavonRef = ref();
    var ruleFormRef = ref();
    var uploaderRef = ref();
    var title = computed(function () {
      return isInEditMode ? "编辑博客" : "新随笔";
    });

    var _mapState = mapState("categoryAbout"),
        categoryCounts = _mapState.categoryCounts;

    var _mapState2 = mapState("tagAbout"),
        tagCounts = _mapState2.tagCounts;

    var categories = computed(function () {
      return categoryCounts.value.map(function (i) {
        return {
          value: i.name,
          label: i.name
        };
      });
    });
    var tags = computed(function () {
      return tagCounts.value.map(function (i) {
        return {
          value: i.name,
          label: i.name
        };
      });
    });
    var ruleForm = reactive({
      id: undefined,
      title: "",
      summary: "",
      content: "",
      category: "",
      tags: [],
      thumbnail: "",
      isDraft: false
    });
    var rules = reactive({
      title: [{
        required: true,
        message: "文章标题不能为空",
        trigger: "change"
      }],
      content: [{
        required: true,
        message: "文章内容不能为空",
        trigger: "change"
      }],
      category: [{
        required: true,
        message: "分类不能为空",
        trigger: "change"
      }]
    }); // 如果有传入文章 id 需要先获取文章信息

    if (isInEditMode) {
      getArticleDetails(props.id).then(function (data) {
        Object.assign(ruleForm, data);
        ruleForm.category = data.categoryName;
        ruleForm.tags = data.tags.map(function (t) {
          return t.name;
        });

        if (data.thumbnail) {
          uploaderRef.value.setImageUrl(data.thumbnail);
          uploaderRef.value.isSuccessLabelVisible = true;
        }
      });
    }

    function onImageAdded(pos, file) {
      uploadImage(file).then(function (url) {
        mavonRef.value.$img2Url(pos, url);
      });
    }

    function handleThumbnailUploaded(url) {
      ruleForm.thumbnail = url;
      document.getElementById("submit-button").disabled = false;
      document.getElementById("draft-button").disabled = false;
    }

    function handleAboutToUploadThumbnail() {
      document.getElementById("submit-button").disabled = true;
      document.getElementById("draft-button").disabled = true;
    }

    function handleRemoveThumbnail(file) {
      ruleForm.thumbnail = "";
    }

    function submitForm(form, isDraft) {
      if (!validateForm(form)) return;
      ruleForm.isDraft = isDraft;
      generateSummary();
      var name = isDraft ? "草稿" : "博客";

      if (!isInEditMode) {
        addArticle(ruleForm).then(function (id) {
          ElMessage.success(name + "保存成功啦");
          setTimeout(function () {
            router.push("/article/" + id);
          }, 1500);
        });
      } else {
        editArticle(ruleForm).then(function (id) {
          ElMessage.success(name + "编辑成功啦");
          bus.emit("articlePosted");
          setTimeout(function () {
            router.push("/article/" + id);
          }, 1500);
        });
      }
    }

    function cancelSubmit() {
      ElMessageBox.confirm("前辈已经想好要取消这篇博客的发表了吗？", "一条友善的提示", {
        confirmButtonText: "你在教我做事？",
        cancelButtonText: "我再想想",
        type: "warning"
      }).then(function () {
        router.push("/");
      });
    }

    function validateForm(form) {
      if (!form) return false;
      form.validate(function (valid) {
        if (!valid) {
          ElMessage.error("必填字段不能为空哦");
          return false;
        }
      });
      return true;
    }

    function generateSummary() {
      if (ruleForm.summary) {
        return;
      }

      var html = markdownIt.render(ruleForm.content);
      ruleForm.summary = html.replace(/<[^>]+>/g, "").slice(0, 150);
    }

    nextTick(function () {
      window.scrollTo({
        top: 0
      });
    });
    return {
      title: title,
      content: content,
      ruleForm: ruleForm,
      ruleFormRef: ruleFormRef,
      uploaderRef: uploaderRef,
      rules: rules,
      categories: categories,
      tags: tags,
      onImageAdded: onImageAdded,
      mavonRef: mavonRef,
      handleThumbnailUploaded: handleThumbnailUploaded,
      handleAboutToUploadThumbnail: handleAboutToUploadThumbnail,
      handleRemoveThumbnail: handleRemoveThumbnail,
      submitForm: submitForm,
      cancelSubmit: cancelSubmit
    };
  },
  props: ["id"]
};